import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.33333 6.66667L14 2M14 2H11M14 2V5M6.66667 9.33333L2 14M2 14H5M2 14L2 11",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgExpandAlt;
